import { CustomDateFilterComponent } from "./component";
import { doesFilterPass } from "./handler";

const CustomDateSetFilter = {
  name: "CustomDateSetFilter",
  doesFilterPass,
  component: CustomDateFilterComponent
};

export default CustomDateSetFilter;
